import { render } from "./FolderItem.vue?vue&type=template&id=50a78b6b&scoped=true"
import script from "./FolderItem.vue?vue&type=script&lang=ts"
export * from "./FolderItem.vue?vue&type=script&lang=ts"

import "./FolderItem.vue?vue&type=style&index=0&id=50a78b6b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-50a78b6b"

export default script